<mat-dialog-content>
        <div class="d-flex justify-content-between">
                <h5 class="fw-semibold">Solardetails</h5>
                <div class="d-flex">
                        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg"
                                alt="close-modal-icon" (click)="onCloseClicked()">
                </div>
        </div>
        <div class="d-flex justify-content-around ">
                <div *ngFor="let details of detailObj" class="d-flex flex-column me-4">
                        <div class="w-100 d-flex justify-content-between">
                                <span class="fw-bold" *ngIf="details.de === 11">Hauptsolarregler</span>
                                <span class="fw-bold" *ngIf="details.de === 12">Zusatzsolarregler</span>
                        </div>
                        <!--                         <div class="w-100 d-flex justify-content-between"> <span> Ladezustand:</span> <span> {{
                                        details.ladezustand}}</span></div> -->
                        <!--                         <div class="w-100 d-flex justify-content-between"> <span> Kapazität:</span> <span> {{
                                        details.verbleibenekapazitat}} %</span></div> -->
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Solarleistung:</span>
                                <span class="text-end">{{ details.solarleistung }} W</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Batteriespannung:</span>
                                <span class="text-end">{{ details.batteriespannung }} V</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Batteriestrom:</span>
                                <span class="text-end">{{ details.batteriestrom }} A</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Lastspannung:</span>
                                <span class="text-end">{{ details.lastspannung }} V</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Laststrom:</span>
                                <span class="text-end">{{ details.laststrom }} A</span>
                        </div>

                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Status:</span>
                                <span class="text-end">{{ getSolarStatusTypeString(details.status) }}</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>WarnCode:</span>
                                <span class="text-end">{{ getSolarWarnCodeString(details.warnzustand) }}</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Reglertyp:</span>
                                <span class="text-end">{{ getSolarChargerTypeString(details.reglertyp) }}</span>
                        </div>

                        <div *ngIf="details.reglertyp === SolarChargerType.Luminax"
                                class="w-100 d-flex justify-content-between gap-4">
                                <span>Fehlercode Gerät:</span>
                                <span class="text-end">{{ getSolarChargerErrorLuminaxString(details.fehlerzustand)
                                        }}</span>
                        </div>
                        <div *ngIf="details.reglertyp === SolarChargerType.Victron"
                                class="w-100 d-flex justify-content-between gap-4">
                                <span>Fehlercode Gerät:</span>
                                <span class="text-end"
                                        *ngIf="details.fehlerzustand !== SolarChargerErrorVictron.Ok; else victronNoError">
                                        <a target="_blank" rel="noopener noreferrer"
                                                [href]="getSolarChargerErrorVictronString(details.fehlerzustand)">{{
                                                details.fehlerzustand }}</a>
                                </span>
                                <ng-template #victronNoError>
                                        <span class="text-end">{{
                                                getSolarChargerErrorVictronString(details.fehlerzustand) }}</span>
                                </ng-template>
                        </div>

                        <div class="w-100 d-flex justify-content-between gap-4">
                                <span>Uhrzeit:</span>
                                <span class="text-end">{{ details.dateTime | date: 'dd.MM.yyyy H:mm' }}</span>
                        </div>
                </div>
        </div>
</mat-dialog-content>
